import React from 'react';

const PromotionSection = ({ promotionClass = '', academicYear = '', status = '', isFromDb = false, primaryColor = '#1e3a8a' }) => {
  // Don't render if no promotion data exists
  if (!status && !promotionClass) {
    return null;
  }

  const isPassed = status === 'PASS';
  const isFailed = status === 'FAIL';

  let promotionText = '—';
  if (isPassed) {
    if (isFromDb && promotionClass) {
      promotionText = `Promoted to ${promotionClass}${academicYear ? ` for Academic Session ${academicYear}` : ''}.`;
    } else if (promotionClass) {
      promotionText = `Eligible for promotion to ${promotionClass}.`;
    } else {
      promotionText = 'Eligible for promotion to next higher grade.';
    }
  } else if (isFailed) {
    promotionText = 'Detained in current class.';
  } else {
    promotionText = status || '—';
  }

  return (
    <div style={{ background: isPassed ? '#f0fdf4' : isFailed ? '#fef2f2' : '#f8fafc', border: `1px solid ${isPassed ? '#86efac' : isFailed ? '#fecaca' : '#e2e8f0'}`, borderRadius: '6px', padding: '10px 14px', fontSize: '11px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <strong style={{ color: isPassed ? '#166534' : isFailed ? '#991b1b' : '#475569', textTransform: 'uppercase' }}>Promotion Decision:</strong>{' '}
        <span style={{ fontWeight: '700', color: isPassed ? '#15803d' : isFailed ? '#b91c1c' : '#334155' }}>
          {promotionText}
        </span>
      </div>
      {status && (
        <div style={{ background: isPassed ? '#166534' : isFailed ? '#991b1b' : '#64748b', color: '#fff', padding: '3px 10px', borderRadius: '4px', fontWeight: '800', fontSize: '10px' }}>
          {status}
        </div>
      )}
    </div>
  );
};

export default PromotionSection;
